import {ICON_TYPES} from '../constants';

export const FilePdfIcon = (): JSX.Element => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path
          d='M12.0083 0H4.16666C2.79166 0 1.66666 1.125 1.66666 2.5V20H18.3333V6.325L12.0083 0ZM12.5 2.84167L15.4917 5.83333H12.5V2.84167ZM16.6667 18.3333H3.33332V2.5C3.33332 2.04167 3.70832 1.66667 4.16666 1.66667H10.8333V7.5H16.6667V18.3333ZM5.80832 10.8333H4.16666V15.8917H5.20832V14.1417H5.80832C6.73332 14.1417 7.48332 13.4 7.48332 12.4833C7.48332 11.5667 6.73332 10.8333 5.80832 10.8333ZM5.80832 13.1H5.21666V11.875H5.80832C6.14999 11.875 6.44166 12.1583 6.44166 12.4833C6.44166 12.8083 6.14999 13.0917 5.80832 13.0917V13.1ZM9.99999 10.8917C9.77499 10.8917 9.56666 10.8917 9.37499 10.8917H8.33332V15.8917H9.37499C9.56666 15.8917 9.77499 15.8917 9.99999 15.8917C10.925 15.8917 11.6667 15.15 11.6667 14.2417V12.55C11.6667 11.6417 10.925 10.9 9.99999 10.9V10.8917ZM10.625 12.5583V14.225C10.625 14.6 10.325 14.85 9.99999 14.85C9.88332 14.85 9.64166 14.85 9.37499 14.85V11.9333C9.64166 11.9333 9.88332 11.9333 9.99999 11.9333C10.325 11.9333 10.625 12.1833 10.625 12.5583ZM13.5417 15.8917H12.5V10.8333H15.8333V11.875H13.5417V13.1H15V14.1417H13.5417V15.8917Z'
          fill='#E35205'
        />
      </g>
    </svg>
  );
};

FilePdfIcon.iconType = ICON_TYPES.FILE_PDF_ICON;
